export default {
  init() {
  },
};

const item = $('.section-faq-rich-text__item');

item.each(function() {
  $(this).click(function() {
    const clickedItem = $(this);

    const open = item => {
      item.addClass('section-faq-rich-text__item--active')
      item.find('.section-faq-rich-text__answer').slideDown();
    }

    if ($('.section-faq-rich-text__item--active').length > 0) {
      $('.section-faq-rich-text__item--active').find('.section-faq-rich-text__answer').slideUp()
      
      if (clickedItem.hasClass('section-faq-rich-text__item--active')) {
        $('.section-faq-rich-text__item--active').removeClass('section-faq-rich-text__item--active');
        return;
      } else {
        $('.section-faq-rich-text__item--active').removeClass('section-faq-rich-text__item--active');
        open(clickedItem);
      }
    } else {
      open(clickedItem);
    }
  })
})



// WEBPACK FOOTER //
// ./scripts/routes/faq-rich-text.js